import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'

ClosureSurvey.JobStatusUpdated = {
  buttonLayout: function() {
    return 'exitButton'
  },

  component: React.createClass({

    render: function() {
      return (
        <div className="form-group">
          <h3 className="mb15 mt10 text-center">You've updated your job status!</h3>        
        </div>
      )
    }
  })
}
